// <inline-film> — poster + play button; click swaps in the film (from <template>) with controls and plays it.
class InlineFilm extends HTMLElement {
  connectedCallback() {
    this.querySelector('.zi-play')?.addEventListener('click', () => {
      const tpl = this.querySelector('template'); if (!tpl) return;
      const v = tpl.content.querySelector('video').cloneNode(true);
      v.autoplay = true; v.preload = 'auto';
      this.replaceChildren(v); this.classList.add('playing');
      v.play().catch(() => {}); v.focus({ preventScroll: true });
    });
  }
}
if (!customElements.get('inline-film')) customElements.define('inline-film', InlineFilm);
